import { useState } from 'react'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import Button from '@mui/material/Button'
import { useDispatch } from 'react-redux'
import { CvsDrawer } from '@components'
import { EditFolder } from '../../../folders/edit-folder'
import { addFolder } from '../../../folders/folders.actions'
import { t } from '@lingui/core/macro'

export const AddFolderButton = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState<boolean>(false)

  return (
    <>
      <Button
        variant="text"
        color="secondary"
        onClick={() => {
          setVisible(!visible)
        }}
        startIcon={<AddCircleOutlineIcon />}
        style={{ lineHeight: 1 }}
      >
        {t`Add folder`}
      </Button>
      <CvsDrawer
        visible={visible}
        onClose={() => {
          setVisible(!visible)
        }}
        title={t`Add folder`}
      >
        <EditFolder
          folder={{ name: '', description: '' }}
          onSubmit={
            (payload => {
              return dispatch(addFolder(payload))
            }) as any
          }
          onClose={() => {
            setVisible(!visible)
          }}
        />
      </CvsDrawer>
    </>
  )
}
